import { exists } from '@/api'

export interface BatchCollectionMgmtCollectionBulkRemovalConditionListItem {
  rdoRemovalType: string
  removalDateFrom: string
  removalDateTo: string
  holdingBranch: string
  rdoCollectionStatus: string
  missingCountFrom: string
  missingCountTo: string
  lastLendDate: string
  limitLendCount: string
  rdoCollectionType: string
  collectionTypeList: string
  rdoHandlingType: string
  handlingTypeList: string
  rdoShelfType: string
  shelfTypeList: string
  removeReason: string
  rdoLastCollectionRemoval: string
  isOutputList: boolean
  isOutputBookPrice: boolean
  rdoDatabaseUpdate: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtCollectionBulkRemovalConditionListItemFromJSON(
  json: any
): BatchCollectionMgmtCollectionBulkRemovalConditionListItem {
  const resp = JSON.parse(json)

  return {
    rdoRemovalType: exists(resp, 'rdo_removal_type')
      ? resp.rdo_removal_type
      : '1',
    removalDateFrom: exists(resp, 'removal_date_from')
      ? resp.removal_date_from
      : '',
    removalDateTo: exists(resp, 'removal_date_to') ? resp.removal_date_to : '',
    holdingBranch: exists(resp, 'holding_branch') ? resp.holding_branch : '',
    rdoCollectionStatus: exists(resp, 'rdo_collection_status')
      ? resp.rdo_collection_status
      : '41',
    missingCountFrom: exists(resp, 'missing_count_from')
      ? resp.missing_count_from
      : '',
    missingCountTo: exists(resp, 'missing_count_to')
      ? resp.missing_count_to
      : '',
    lastLendDate: exists(resp, 'last_lend_date') ? resp.last_lend_date : '',
    limitLendCount: exists(resp, 'limit_lend_count')
      ? resp.limit_lend_count
      : '',
    rdoCollectionType: exists(resp, 'rdo_collection_type')
      ? resp.rdo_collection_type
      : '1',
    collectionTypeList: exists(resp, 'collection_type_list')
      ? resp.collection_type_list
      : '',
    rdoHandlingType: exists(resp, 'rdo_handling_type')
      ? resp.rdo_handling_type
      : '1',
    handlingTypeList: exists(resp, 'handling_type_list')
      ? resp.handling_type_list
      : '',
    rdoShelfType: exists(resp, 'rdo_shelf_type') ? resp.rdo_shelf_type : '1',
    shelfTypeList: exists(resp, 'shelf_type_list') ? resp.shelf_type_list : '',
    removeReason: exists(resp, 'remove_reason') ? resp.remove_reason : '',
    rdoLastCollectionRemoval: exists(resp, 'rdo_last_collection_removal')
      ? resp.rdo_last_collection_removal
      : '1',
    isOutputList: exists(resp, 'is_output_list') ? resp.is_output_list : false,
    isOutputBookPrice: exists(resp, 'is_output_book_price')
      ? resp.is_output_book_price
      : false,
    rdoDatabaseUpdate: exists(resp, 'rdo_database_update')
      ? resp.rdo_database_update
      : '2',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
